<div class="dr-page">

    <!-- Header -->
    <div class="dr-header">
        <div class="dr-header-left">
            <h2 class="dr-title">Damage reports</h2>
            @if (!detailsDialog) {
            <span class="dr-subtitle">
                <span>{{ pendingCount() }} pending</span>
                <span>·</span>
                <span>{{ acknowledgedCount() }} acknowledged</span>
                <span>·</span>
                <span>{{ rejectedCount() }} rejected</span>
            </span>
            }
        </div>
        <p-button label="Export" class="export-btn" styleClass="add-button" variant="text" [disabled]="true">
            <ng-template #icon>
                <img src="assets/icons/download.svg" alt="Export" />
            </ng-template>
        </p-button>
    </div>

    <!-- Tabs (hidden when pending details open) -->
    @if (!detailsDialog) {
    <div class="dr-tabs">
        <button class="dr-tab dr-tab--pending"
            [class.dr-tab--active]="activeTab === 'PENDING'"
            (click)="setTab('PENDING')">Pending</button>
        <button class="dr-tab dr-tab--acknowledged"
            [class.dr-tab--active]="activeTab === 'ACKNOWLEDGED'"
            (click)="setTab('ACKNOWLEDGED')">Acknowledged</button>
        <button class="dr-tab dr-tab--rejected"
            [class.dr-tab--active]="activeTab === 'REJECTED'"
            (click)="setTab('REJECTED')">Rejected</button>
    </div>
    }

    <!-- Table (Acknowledged / Rejected) -->
    @if (!detailsDialog) {
    <p-card class="mt-3">
        <app-table-component
            [data]="reports()"
            [columns]="tableColumns"
            [totalRecords]="totalRecords()"
            [rows]="rows"
            [first]="first"
            (pageChange)="onPageChange($event)"
            [tableName]="''"
            [searchControl]="searchControl"
            [showColumnSelector]="false"
            [showClearFilters]="false"
            [customFilters]="[reportTypeFilter, damageTypeFilter, createdDateFilter]"
            [preserveFilterKeys]="['status']"
            searchPlaceholder="Search..." />
    </p-card>
    } @else {
    <!-- Pending details view -->
    <app-damage-report-details
        [report]="selectedReport"
        [currentIndex]="selectedReportIndex"
        [total]="reports().length"
        [activeTab]="activeTab"
        (acknowledge)="openAcknowledgeReport()"
        (reject)="openRejectReport()"
        (prev)="onDetailsPrev()"
        (next)="onDetailsNext()"
        (tabChange)="setTab($event)" />
    }
</div>

<!-- Lightbox -->
@if (lightboxOpen && lightboxReport) {
<div class="dr-lightbox-backdrop" (click)="lightboxOpen = false"
    (keyup.escape)="lightboxOpen = false" tabindex="0" role="dialog" aria-modal="true">
    <div class="dr-lightbox" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" tabindex="-1">
        <div class="dr-lightbox-header">
            <span class="dr-lightbox-title">Report ID : #{{ lightboxReport.id }}</span>
            <button type="button" class="dr-lightbox-close" (click)="lightboxOpen = false">✕</button>
        </div>
        <div class="dr-lightbox-body">
            <button type="button" class="dr-lightbox-nav dr-lightbox-nav--prev"
                (click)="lightboxPrev()" [disabled]="lightboxIndex === 0">&#8249;</button>
            <img [src]="lightboxReport.images[lightboxIndex]" alt="Damage photo" class="dr-lightbox-img" />
            <button type="button" class="dr-lightbox-nav dr-lightbox-nav--next"
                (click)="lightboxNext()" [disabled]="lightboxIndex === lightboxReport.images.length - 1">&#8250;</button>
        </div>
    </div>
</div>
}

@defer (when acknowledgeReportDialog; prefetch on idle) {
<app-acknowledge-damage-report-form
    [selectedReport]="selectedReport"
    (damageReportAcknowledged)="onReportAcknowledged()"
    [(visibility)]="acknowledgeReportDialog" />
}

@defer (when rejectReportDialog; prefetch on idle) {
<app-reject-damage-report-form
    [selectedReport]="selectedReport"
    (damageReportRejected)="onReportRejected()"
    [(visibility)]="rejectReportDialog" />
}
